module.exports = __webpack_public_path__ + "img/standard-quiz-intro-wireframes.7daa29ae.svg";